import React from 'react';

function Footer() {
    return (
        <footer>
            <div className="container">
                <p>© 2022 All Rights Reserved</p>
            </div>
        </footer>
    );
}

export default Footer;